const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  SETTINGS: "/settings",
  TENANTS: "/tenants",
  USER: "/users",
  ADD_EDIT_USER: "/user/:id",
  USAGECOUNT: "/usage-tracker",
  CREDIT_USAGE: "/credit-usage",
  GRANT_CREDITS: "/grant-credits",
  COMPANYPROFILE: "/company-profile",

  COMPANYPROFILEMANUAL: "/company-profile-manual",
  FORGOTPASSWORD: "/forgotPassword",
  RESETPASSWORD: "/reset-password",
  ADMIN_REQUESTS: "/admin/requests",

  COMPANYPROFILEINFO: "/company-profile-info",
  USAGELOG: "/usage-logs",
  ADD_COMPANY_INDIVIDUAL: "/add/:mode",
  NOTIFICATION: "/notification",
  CONTACT: "/contact",
  USER_DETAILS: (userId: string) => `/users/${userId}`,
  SUBSCRIPTION_PLAN: "/subscription",
  TEAMS: "/teams",
  SCRIPT: "/script",
  SCRIPT_DETAILS: "/script-details/:scriptId",
  CONTACT_REQUESTS: "/contact-requests",
  SOCIAL_POSTS: "/social-posts",
  PRACTICE_ENGINE: "/practice-engine",
  DIGITAL_TWIN_TEMPLATES: "/digital-twin-templates",
  NOT_FOUND: "*",
};

export default ROUTES;
